import { ElectronAPI, getElectronAPI } from "@org-avp/avp-avengers-ui-framework-electron-api";
import { useEffect, useState } from "react";

type Invoke = ElectronAPI["invoke"];
export const useInvokeElectronAPI = <K extends keyof Invoke, T extends Invoke[K]>(k: K, ...args: Parameters<T>): Awaited<ReturnType<T>> | undefined => {
  const [result, setResult] = useState<Awaited<ReturnType<T>>>();
  const electronAPI = getElectronAPI();
  useEffect(
    () => {
      type WidenT = (...args: Parameters<T>) => Promise<Awaited<ReturnType<T>>>;
      const invokeMethod = electronAPI?.invoke[k] as WidenT | undefined;
      invokeMethod?.(...args)?.then(setResult);
    },
    [args, electronAPI, k],
  );

  return result;
};
